import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'tg-modal';

import {gettext} from 'utils/text';


class ConfirmModal extends React.Component {

    static propTypes = {
        modal: PropTypes.shape({
            selectedOrders: PropTypes.arrayOf(PropTypes.shape({
                id: PropTypes.number.isRequired,
                full_number: PropTypes.string.isRequired,
                status: PropTypes.string.isRequired,
            })),
            warnings: PropTypes.arrayOf(PropTypes.shape({
                key: PropTypes.string.isRequired,
                msg: PropTypes.string.isRequired,
            })),
            description: PropTypes.string.isRequired,
            onConfirm: PropTypes.func.isRequired,
        }),
        onHide: PropTypes.func.isRequired,
    };

    static defaultProps = {
        modal: null,
    };

    renderWarnings = (modal) => {
        if (modal && modal.warnings && modal.warnings.length) {
            return (
                <div className="alert alert-danger" role="alert">
                    {
                        modal.warnings.map(
                            warning => (
                                <div key={warning.key}>{warning.msg}</div>
                            ),
                        )
                    }
                </div>
            );
        }
        return null;
    };

    renderSelectedOrders = (modal) => {
        if (modal && modal.selectedOrders && modal.selectedOrders.length) {
            return (
                <div className="alert alert-info" role="alert">
                    <div>{gettext("Selected orders:")}</div>
                    {
                        modal.selectedOrders
                            .map(order => <span key={order.id}>{order.full_number}</span>)
                            .reduce((prev, curr) => [prev, ', ', curr])
                    }
                </div>
            );
        }
        return null;
    };

    render() {
        const {modal, onHide} = this.props;

        return (
            <Modal
                isOpen={!!modal}
                onCancel={onHide}
                onConfirm={modal && modal.onConfirm}
                title={gettext("Confirmation")}
            >
                <div className="tg-modal-body pt-0 pl-4">
                    {this.renderWarnings(modal)}
                    {this.renderSelectedOrders(modal)}
                    {modal && modal.description}
                </div>
                <div className="modal-footer">
                    <span
                        className="btn btn-secondary btn-lg mr-3"
                        onClick={onHide}
                    >
                        {gettext('Cancel')}
                    </span>
                    <span
                        className="btn btn-primary btn-lg"
                        onClick={() => {
                            if (modal) {
                                modal.onConfirm();
                            }
                            onHide();
                        }}
                    >
                        {gettext('OK')}
                    </span>
                </div>
            </Modal>
        );
    }
}


export default ConfirmModal;



// WEBPACK FOOTER //
// ./src/components/ConfirmModal.js